'use client';

import { useState } from 'react';
import { motion } from 'framer-motion';

interface PricingToggleProps {
  onChange: (isYearly: boolean) => void;
}

export default function PricingToggle({ onChange }: PricingToggleProps) {
  const [isYearly, setIsYearly] = useState(false);

  const handleToggle = (yearly: boolean) => {
    setIsYearly(yearly);
    onChange(yearly);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex items-center justify-center bg-zinc-100 dark:bg-zinc-800/50 p-1.5 rounded-full">
        <button
          type="button"
          onClick={() => handleToggle(false)}
          className={`relative px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            !isYearly
              ? 'text-white bg-[#4d2ef5] shadow-lg shadow-[#4d2ef5]/20'
              : 'text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white'
          }`}
        >
          Monthly
        </button>
        <button
          type="button"
          onClick={() => handleToggle(true)}
          className={`relative px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            isYearly
              ? 'text-white bg-[#4d2ef5] shadow-lg shadow-[#4d2ef5]/20'
              : 'text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white'
          }`}
        >
          <span className="relative z-10">Yearly</span>

          {/* Save badge */}
          {isYearly && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8, y: -5 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#4d2ef5] to-[#7d51ed] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg whitespace-nowrap"
            >
              SAVE 20%
              {/* Decorative elements */}
              <svg
                className="absolute -bottom-2 left-1/2 -translate-x-1/2 text-[#4d2ef5] size-4"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              {/* Animated sparkles */}
              <span className="absolute -right-1 -top-1 animate-pulse">✨</span>
              <span className="absolute -left-1 -top-1 animate-pulse delay-300">
                ✨
              </span>
            </motion.div>
          )}
        </button>
      </div>
    </div>
  );
}
